import axios from './index';

// 分页查询唛头模板
export const pageQueryMarkTemplate = (params) =>
  axios.post(
    '/markTemplate/pageQueryMarkTemplate',
    params
  );

// 查询客户信息
export const getCustomerInfo = (params) =>
  axios.get(
    '/markFieldBasic/getCustomerInfo',
    { params: params }
  );

// 模糊查询字段信息
export const queryByFieldName = (params) =>
  axios.get(
    '/markFieldBasic/queryByFieldName',
    { params: params }
  );

// 保存模板信息
export const saveMarkTemplateInfo = (params) =>
  axios.post(
    '/markTemplate/saveMarkTemplateInfo',
    params
  );

// 模板管理，模板渲染
export const viewTemplate = (params) =>
  axios.get(
    '/markTemplate/viewTemplate',
    { params: params }
  );

// 模板的启用停用
export const disableTemplate = (params) =>
  axios.get(
    '/markTemplate/disableTemplate',
    { params: params }
  );
